'use strict';
import { EwSiteApp } from '../../app/ewsiteapp.js';

EwSiteApp.requires.push('bgf.paginateAnything');

function select2init() {
	$('select').select2({ minimumResultsForSearch: -1 });
	$('select.select2_with_dynamic_placeholder').select2({
		minimumResultsForSearch: -1,
		placeholder() {
			return $(this).data('placeholder');
		}
	});
}

EwSiteApp.controller('ClientvoteCtrl', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {
	$scope.dataUrl = clientVoteData.data_url;
	$scope.companies = [];
	$scope.toggleOpen = function(company) {
		company.open = !company.open;
		if (company.open) {
			$timeout(select2init, 0);
		}
	};
	$scope.resetMonths = function(company) {
		company.selected_month = '';
	};
	$scope.loadData = function() {
		if (!$scope.dataUrl) return;
		$http.get($scope.dataUrl).then(function(response) {
			if (response.data.success) {
				$scope.companies = response.data.list;
			}
		});
	};
	$scope.loadData();
}]);

EwSiteApp.controller('ClientvoteCompanyCtrl', ['$scope', '$http', function($scope, $http) {
	$scope.dataUrl = companyData.data_url;
	$scope.back_url = companyData.back_url;
	$scope.starting_page = 0;
	$scope.company = companyData.company;
}]);

EwSiteApp.directive('inputColorPick', ['$document', '$timeout', function($document, $timeout) {
	return {
		restrict: 'E',
		scope: { itemModel: '=?ngModel' },
		templateUrl: element => element.getAttribute('template-url') || 'clientvote/inputcolorpick.html',
		controller: ['$scope', function($scope) {
			$scope.show = false;
			$scope.toggle = () => $scope.show = !$scope.show;
			$scope.close = () => $scope.show = false;
			$scope.setColor = value => { $scope.itemModel = value; $scope.close(); };
			$scope.isActive = value => $scope.itemModel === value;
		}],
		link(scope, element) {
			if (scope.itemModel === undefined) scope.itemModel = 'black';
			$document.on('click', event => {
				if (!element[0].contains(event.target)) {
					$timeout(scope.close, 50);
				}
			});
		}
	};
}]);

window.modalRejectHandler = function(result) {
	console.log(result);
};
